import { SHEET_GROUP_MAIN, SHEETS_LIST } from '../../lesson.constants';
import { LessonWorksheetFragment } from './__generated__/LessonWorksheetFragment';
import Sheets from 'approot/lesson/sheets';
import { useSheetPreviewData } from 'approot/lesson/lesson.utils';
import { LESSON } from 'global/constants';
import {
  NotificationActions,
  NotificationContent,
  NotificationTip,
  NotificationTipText,
} from 'approot/shared/notifications/notification-tip.style';
import { PrimaryButton } from 'approot/shared/styles/buttons';
import { ContentPageHeading18 } from 'approot/shared/content-page/content-page.style';
import { LessonStimulusFragment_stimulusResources } from '../stimulus/__generated__/LessonStimulusFragment';
import StimulusGuest from 'approot/shared/stimulus/stimulus-guest';
import { LessonPrintablesFragment_printableAnswerSheet } from '../lesson-printables/__generated__/LessonPrintablesFragment';
import PreviousPrintables from '../lesson-printables/previous-printables';

export type Props = {
  contentId: number;
  lesson: LessonWorksheetFragment;
  stimulus: LessonStimulusFragment_stimulusResources[];
  printableAnswerSheet: LessonPrintablesFragment_printableAnswerSheet | null;
  showLessonTab: () => void;
  hasActivities: boolean;
};

const LessonWorksheetsGuest = ({
  contentId,
  lesson: { id, worksheet },
  stimulus,
  printableAnswerSheet,
  showLessonTab,
  hasActivities,
}: Props) => {
  const data = useSheetPreviewData(LESSON, contentId, {
    worksheet,
  });

  const sheetsList = [...SHEETS_LIST[data.type]];

  return (
    <>
      <NotificationTip $marginBottom={16} $noMaxWidth>
        <NotificationContent>
          <NotificationTipText>
            There is a new enhanced format of this lesson available.
          </NotificationTipText>
          <NotificationActions>
            <PrimaryButton type="button" $isSmall onClick={showLessonTab}>
              ✨ See Enhanced Lesson
            </PrimaryButton>
          </NotificationActions>
        </NotificationContent>
      </NotificationTip>

      <ContentPageHeading18 data-selector="content-section-title">
        Lesson Pages
      </ContentPageHeading18>
      <Sheets
        fourColumnLayout
        lesson={data}
        sheetDefinitions={sheetsList}
        sheetGroup={SHEET_GROUP_MAIN}
        hasActivities={hasActivities}
      />

      {stimulus.length > 0 && (
        <>
          <ContentPageHeading18 data-selector="content-section-title">
            Stimulus
          </ContentPageHeading18>
          <StimulusGuest
            stimulus={{
              id,
              stimulusResources: stimulus,
            }}
          />
        </>
      )}

      {printableAnswerSheet && (
        <PreviousPrintables
          contentId={id}
          contentType={LESSON}
          printableAnswerSheet={printableAnswerSheet}
        />
      )}
    </>
  );
};

export default LessonWorksheetsGuest;
